import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

function CloseWorkDayModal(props) {
  const { model, setOpen, showNotify, reload } = props;

  const title =
    !!model && !!model.zone
      ? `Hora cierre ${model.zone.description} - ${model.canal.description}`
      : '';

  return (
    <Modal
      title={title}
      model={model}
      setOpen={setOpen}
      showNotify={showNotify}
      reload={reload}
      entity="ordm/closing-work-day"
    >
      <TextField
        label="Hora de cierre"
        type="time"
        name="close_hour"
        margin="normal"
        fullWidth
        defaultValue={!!model ? model.close_hour : '00:00'}
        inputProps={{ step: 300 }}
        InputLabelProps={{ shrink: true }}
        required
      />
    </Modal>
  );
}

export default CloseWorkDayModal;
